import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { FC } from 'react';

interface DBHeaderProps {
  title: string;
  subtitle: string;
}

const DBHeader: FC<DBHeaderProps> = ({ title, subtitle }) => {
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box ml={smScreen ? 0 : 8} mt={6}>
      <Typography
        fontFamily="Lufga"
        fontWeight="500"
        fontSize={smScreen ? '24px' : '32px'}
        color="var(--primary-blue)"
      >
        {title}
      </Typography>
      <Typography
        fontFamily="Outfit"
        fontWeight="400"
        fontSize="14px"
        color="var(--instructions)"
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

export default DBHeader;
